import * as React from "react";
const SvgArrowForward = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#B0B0DA", d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z" }));
export default SvgArrowForward;
